import axios from "axios";

const axiosApiInstance = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost',
  // : 'https://d.dts-log.com/',
  headers: {
    'Content-type': 'application/json',
    'Accept': '*/*'
  },
});


// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async config => {
    const keys = localStorage.getItem("access_token");
    if (keys == null || keys == undefined) {
      return config;
    }
    let LangCode = localStorage.getItem("lang");
    LangCode = (LangCode == undefined)?'zhHant':LangCode;
    config.headers = {
      'Authorization': `Bearer ${keys}`,
      'Accept': '*/*',
      'Content-type': 'application/json',
      'LangCode': LangCode
    }

    return config;
  },
  error => {
    Promise.reject(error)
});

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config;
  // console.log(originalRequest);
  if (error.response.status === 490 && !originalRequest._retry) {
    originalRequest._retry = true;
    const response = await axiosApiInstance.post("/CGSService/FrogiGo/PublicService/RefreshToken",{},{withCredentials: true,});
    console.log("Response interceptor for API calls");
    if (response.data.isSuccess) {
      localStorage.setItem('access_token', response.data.Msg);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.Msg;
    } else {
      console.log(response.data.Msg);
      localStorage.removeItem("member_no");
      localStorage.removeItem("access_token");
      window['vue'].$router.push({ name: 'home',query: { relogin: true } });
    }
    return axiosApiInstance(originalRequest);
  }
  return Promise.reject(error);
});



export default axiosApiInstance;
